import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    loading: false,
    needToLoadData: false,
    teamNames: [],
}

export default handleActions({
    [ActionTypes.LOADING_SET]: (state, {payload: loading}) => ({
        ...state,
        loading,
    }),
    [ActionTypes.NEED_TO_LOAD_DATA_SET]: (state, {payload: needToLoadData}) => ({
        ...state,
        needToLoadData,
    }),
    [ActionTypes.TEAM_NAMES_SET]: (state, {payload: teamNames}) => ({
        ...state,
        teamNames,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/reducer.js